import React from 'react'
import {formatDate} from '../../lib/util'

const Date = ({entity, entityInfo, field, fieldInfo, value, tag, data, ...props}) => {
	const Tag = tag || 'div'
	
	return <Tag {...props}>{formatDate(value)}</Tag>
}
export default Date
